export default {
  title: "Feedback",

  nameField: "Your Name",
  phoneField: "Contact Phone Number",
  messageField: "Message",

  send: "Send",
  sentSuccess: "Successfully sent",

  errors: {
    send_error: "An error occurred while sending your message",
    added_error: "An error occurred while creating your feedback",
    server: "Server error. Try again later."
  }
};
